import { render, staticRenderFns } from "./performance_bar_app.vue?vue&type=template&id=71228c4c"
import script from "./performance_bar_app.vue?vue&type=script&lang=js"
export * from "./performance_bar_app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports